@if (elemSetup?.elemType === 'Number') {
  <motn-tile-number
    [elemDef]="$any(elemSetup)"
    (openTileEditor)="openTileEditor()"
  ></motn-tile-number>
}

@if (elemSetup?.elemType === 'MultiChoice') {
  <motn-tile-multi-choice
    [elemDef]="$any(elemSetup)"
    (openTileEditor)="openTileEditor()"
  ></motn-tile-multi-choice>
}

@if (elemSetup?.elemType === 'Toggle') {
  <motn-tile-toggle
    [elemDef]="$any(elemSetup)"
    (openTileEditor)="openTileEditor()"
  ></motn-tile-toggle>
}

@if (editingTile && tileId) {
  <motn-tile-editor
    [tileId]="tileId"
    (closed$)="editingTile = false"
    (deleted$)="editingTile = false"
  ></motn-tile-editor>
}
